<core-toggle
    #coreToggle
    [attr.label]="label"
    [attr.checked]="checked"
    [attr.disabled]="disabled"
>
</core-toggle>
